import {css} from 'lit';
export const styles = css`:host{display:flex;flex-direction:column}.critical-action-item{display:flex;align-items:center;gap:.5rem}.critical-action-sub-item{margin-top:.5rem;margin-left:2rem}.critical-action-item-parent{font-weight:700}`;
export default styles;
